/**
 * Politique de mot de passe — à garder synchronisée avec
 * utils/passwordPolicy.js côté backend (même règles, mêmes messages).
 */

export const PASSWORD_MIN_LENGTH = 10;

export const PASSWORD_RULE_MESSAGE =
  `Le mot de passe doit contenir au moins ${PASSWORD_MIN_LENGTH} caractères, dont au moins une lettre et un chiffre.`;

const COMMON_PASSWORDS = new Set([
  '1234567890', '0123456789', '1234512345', '1111111111', '0000000000',
  'azerty1234', 'azertyuiop', 'qwerty1234', 'qwertyuiop', 'password1', 'password12',
  'password123', 'motdepasse1', 'motdepasse123', 'admin12345', 'admin123456',
  'abcdef1234', 'abc1234567', 'a123456789', '123456789a', 'bonjour123',
  'soleil1234', 'welcome123', 'changeme123', 'shemspaie1', 'shemspaie123',
  'shems12345', 'shems2024', 'shems2025', 'shems2026', 'chantier123',
  'maroc12345', 'casablanca1', 'paie123456'
]);

/** Retourne null si le mot de passe est valide, sinon le message d'erreur. */
export const checkPasswordStrength = (password, login = '') => {
  const value = String(password || '');

  if (value.length < PASSWORD_MIN_LENGTH || !/[a-zA-Z]/.test(value) || !/[0-9]/.test(value)) {
    return PASSWORD_RULE_MESSAGE;
  }

  if (COMMON_PASSWORDS.has(value.toLowerCase())) {
    return 'Ce mot de passe est trop courant. Merci d’en choisir un autre.';
  }

  const normalizedLogin = String(login || '').trim().toLowerCase();
  if (normalizedLogin.length >= 3 && value.toLowerCase().includes(normalizedLogin)) {
    return 'Le mot de passe ne doit pas contenir le login.';
  }

  return null;
};
